import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  savedSignatureContainer: {
    marginTop: theme.spacing(2),
    maxHeight: "270px",
    overflowY: "auto",
    paddingRight: theme.spacing(2),
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: grey[500],
      borderRadius: theme.shape.borderRadius,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: grey[300],
    },
  },
  signatureItem: {
    justifyContent: "space-between",
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
    border: `1px solid ${grey[300]}`,
    backgroundColor: "white",
    marginBottom: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  selectedSignatureItem: {
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.secondary.main,
  },
  signatureText: {
    fontSize: "14px",
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  avatar: {
    width: "60px",
    height: "60px",
    objectFit: "contain",
    marginLeft: theme.spacing(1.5),
  },
  avatarText: {
    width: "50%",
    maxHeight: "60px",
    objectFit: "contain",
    objectPosition: "center",
    overflow: "hidden",
  },
  infoIcon: {
    color: grey[500],
    fontSize: "18px",
    cursor: "pointer",
  },
}));
